export default function ($scope, pontos, map, google, $timeout, $compile) {
    var _ = require('lodash');
    var $ = require('jquery');
    var rd = require('diacritics').remove;
    var MarkerWithLabel = require('markerwithlabel')(google.maps);
    var templates = require.context("./templates", true, /\.html$/);
    var icons = require.context("./icons", true, /.*/);


    var getInfoWindow = function ($scope, e) {
        var compile = function(tpl, $scope) {
            var c = $compile(templates(tpl))($scope);
            return c[0];
        };

        $scope.ecoponto = e;
        if (e.ec === 'P') {
            $scope.ecoponto.ec = 'Pendente';
        }
        
        return compile("./advanced.html", $scope);
        
    };
    
    var getIcon = function(e) { 
        return  icons('./1100l.png');
    };
        
    var getSmallIcon = function(e) { 
        return {
            url: getIcon(e), 
            scaledSize: new google.maps.Size(6, 8), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };
    };
    
    $scope.pontos1100 = _.filter(pontos, function(e) { 
        return e.latitude && e.longitude; 
    });
    
    $scope.info = new google.maps.InfoWindow({content: '<div></div>'});

    //setup the markers
    $scope.layers.push({name: 'Pontos 1100L', visible: false, hidden: (_.indexOf($scope.access, 'amarsul') === -1)});
    

    _.each($scope.pontos1100, function(e){
        e.cod = "" + e.cod;


        e.marker = new google.maps.Marker({
            position: new google.maps.LatLng(e.latitude, e.longitude),
            map: map,
            icon: getSmallIcon(e),
            title: e.cod
        });


        //infowindow on click
        google.maps.event.addListener(e.marker, 'click', function () {
            $timeout(function () {
                map.setCenter(e.marker.getPosition());
                e.img = require('./images/i1100L.jpg');
                $scope.info.close();
                $scope.info.setContent(getInfoWindow($scope, e));
                $scope.info.open($scope.map, e.marker);
            });
        });
    });
    
    var isColocado = function(e) { return e.status === "S";};
    var isEliminado = function(e) { return (e.status !== "S");};
    
    
    var setMarker = function(e) {
        if (!e.marker) {
            return;
        }
        
        //should show lbled marker
        var _lbl_marker = e.visible 
                && _.indexOf($scope.access, 'amarsul') !== -1 
                && map.getBounds() 
                && map.getBounds().contains(e.marker.getPosition())
                && map.getZoom() >= 16;
        
        //should show simple marker
        var _marker = e.visible && !_lbl_marker &&  map.getBounds() && map.getBounds().contains(e.marker.getPosition());
        var _big_marker = map.getZoom() >= 16 && _marker;

        if ((!!e.marker.getMap() !== _marker) || (!!e.big_marker !== _big_marker)) {
            e.marker.setMap(_marker ? $scope.map : null);
            
            //scales marker, if needed
            if (!!e.big_marker !== _big_marker) {
                if (_big_marker) {
                    e.marker.setIcon(getIcon(e));
                } else {
                    e.marker.setIcon(getSmallIcon(e));
                }
                e.big_marker = _big_marker;
            }
        }
        
        if (!e.lbl_marker && _lbl_marker) {
            
            e.lbl_marker = new MarkerWithLabel({
                position: new google.maps.LatLng(e.latitude, e.longitude),
                map: map,
                title: e.cod,
                icon: getIcon(e),
                labelContent: e.cod,
                labelAnchor: new google.maps.Point(22, 0),
                labelClass: 'eco-label', // the CSS class for the label 
                labelStyle: {opacity: 0.75}
            });
            
            google.maps.event.addListener(e.lbl_marker, 'click', function () {
                $timeout(function () {
                    map.setCenter(e.marker.getPosition());
                    e.img = require('./images/i1100L.jpg');
                    $scope.info.close();
                    $scope.info.setContent(getInfoWindow($scope, e));
                    $scope.info.open($scope.map, e.marker);
                });
            });
            
            
        }
        
        if (!!e.lbl_marker && (!!e.lbl_marker.getMap() !== _lbl_marker)) {
            e.lbl_marker.setMap(_lbl_marker ? $scope.map : null);
            
            if (!!e.lbl_marker && !_lbl_marker) {
                e.lbl_marker = false;
            }
        }
    };
    
    var hasCircuito = function(e, searched) {
        for (var i = 0; i < e.cir.length; i++) { 
            if (e.cir[i].toLowerCase().indexOf(searched) === 0) {
                return true;
            }
        }
        
        return false;
    }

    
    map.addListener('bounds_changed' , _.debounce(function() {
        _.each($scope.pontos1100, setMarker)
    },200));

    //refresh fcn
    return function() {
        var _mun_activos = _.map(_.filter($scope.municipios, 'visible'),'name');
        var _layers_activas = _.map(_.filter($scope.layers, 'visible'),'name');
                
        //updates status
        _.each($scope.pontos1100, function(e){
            e.visible = _.indexOf(_layers_activas, 'Pontos 1100L') !== -1 
                    && _.indexOf(_mun_activos, e.con) !== -1 
                    && e.cod.toLowerCase().indexOf($scope.search.toLowerCase()) === 0
                    && ($scope.circuito == '' || hasCircuito(e, $scope.circuito.toLowerCase()))
                    && _.indexOf($scope.access, 'amarsul') !== -1;
        });

        _.each($scope.layer, function(l){
            if (l.name == 'Pontos 1100L') {
                l.hidden = _.indexOf($scope.access, 'amarsul') === -1;
                console.log(l);
            }
        })

        _.each($scope.pontos1100, setMarker);
    };
}




// WEBPACK FOOTER //
// ./src/pontos1100/setup.js